/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlan/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Description from './Description/index'
import Discount from './Discount/index'
import Info from './Info/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlan({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let paymentPlanNameValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paymentPlanTotalToPayValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'total_to_pay',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="PaymentPlan.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PaymentPlan.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PaymentPlan.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.name"
 text={paymentPlanNameValueData}
 weight="medium"
 maxWidth={160}
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 overflowX="hidden"
 display="block"
/>
<Discount
  viewPath={`${viewPath}/Discount`}
/>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Info
  viewPath={`${viewPath}/Info`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.total_to_pay"
 format="/Data/format.js numberMoney"
 text={paymentPlanTotalToPayValueData}
 weight="medium"
/>
</div>
</div>
{children}
</React.Fragment>)
}